enum ERowTypes {
  'filled',
  'active',
  'empty',
}

export default ERowTypes;